import type { UploadedFilePayload } from '../types/content';

export async function fileToPayload(file: File): Promise<UploadedFilePayload> {
  const base64 = await readFileAsBase64(file);
  return {
    name: file.name,
    mimeType: file.type,
    base64,
  };
}

function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = String(reader.result || '');
      const [, base64 = ''] = result.split(',');
      resolve(base64);
    };

    reader.onerror = () => {
      reject(reader.error || new Error('Nao foi possivel ler o arquivo selecionado.'));
    };

    reader.readAsDataURL(file);
  });
}
